export default {
  namespaced: true,

  state: {
    hasData: false,
    info: {},
    roles: {},
    os: false,
  },

  mutations: {
    EMAIL_VERIFIED(state, bool) {
        state.emailVerified = bool;
    },

    HAS_DATA(state, bool) {
        state.hasData = bool;
    },

    PATCH_INFO(state, user) {
        state.info = user;
    },

    SET_ROLES(state, userTeamData) {
        if (userTeamData.team.team_users) {
            let currentTeamUser = userTeamData.team.team_users.find(item => item.user.id === userTeamData.user.id)
            // currentTeamUser.roles = ["Cloud Admin","Billing Admin"]
            if (currentTeamUser.roles) {
              let data = {
                  "Cloud Admin": currentTeamUser.roles.indexOf('Cloud Admin') > -1,
                  "Cloud Viewer": currentTeamUser.roles.indexOf('Cloud Viewer') > -1,
                  "EMK Admin": currentTeamUser.roles.indexOf('EMK Admin') > -1,
                  "EMK Viewer": currentTeamUser.roles.indexOf('EMK Viewer') > -1,
                  "Customer Owner": userTeamData.team.customer.owner.email_address === userTeamData.user.email_address,
                  "Team Owner": userTeamData.team.owner.email_address === userTeamData.user.email_address,
                  "Team Admin": currentTeamUser.roles.indexOf('Team Admin') > -1,
                  "Billing Admin": currentTeamUser.roles.indexOf('Billing Admin') > -1,
              }
              state.roles = data;
            }
        }
    },

    PATCH_USER(state, user) {
        state.info.first_name = user.first_name;
        state.info.last_name = user.last_name;
        if (user.phone_number) {
            state.info.phone_number = user.phone_number;
        }
    },

    PATCH_EXPERTISE(state, knowledge) {
        state.info.knowledge = knowledge;
    },

    SET_OS_DATA(state, data) {
        state.info.os = data;
    },
  },

  actions: {
    PATCH_INFO(context, user) {
        context.commit('PATCH_INFO', user);
    },

    PATCH_USER(context, user) {
        context.commit('PATCH_USER', user);
    },
  }
}
